import { OTP_CODE_LENGTH, OTP_DIGITS_REGEX } from 'shared/utils/string/otp';
import { z } from 'zod';

export const otpValidationMessages = {
  invalid: 'The code you entered is incorrect.',
  required: 'Code required',
};

export const otpSchema = z
  .string({ error: otpValidationMessages.required })
  .min(1, { error: otpValidationMessages.required })
  .length(OTP_CODE_LENGTH, { error: otpValidationMessages.invalid })
  .regex(OTP_DIGITS_REGEX, { error: otpValidationMessages.invalid });
